import { UserV2 } from '@/graphql/codegen/graphql'

export const displayName = (user: UserV2) =>
  user?.firstName && user?.lastName ? `${user?.firstName} ${user?.lastName}` : 'Unknown';


